
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 0C4.25 0 0 4.249 0 9.5c0 1.666.435 3.294 1.26 4.73l-1.224 3.8a.742.742 0 00.934.934l3.8-1.224A9.479 9.479 0 009.5 19c5.25 0 9.5-4.249 9.5-9.5C19 4.25 14.751 0 9.5 0zm0 17.516A7.992 7.992 0 015.257 16.3a.743.743 0 00-.62-.077l-2.745.884.884-2.744a.743.743 0 00-.077-.621A7.994 7.994 0 011.484 9.5c0-4.42 3.596-8.016 8.016-8.016S17.516 5.08 17.516 9.5 13.92 17.516 9.5 17.516z","fill":"#fff"}})])
          )
        }
      }
    